import { api } from "@/lib/api";

export const CUSTOMER_ARCHIVE_PAGE_SIZE = 50;

export async function fetchCustomerArchivePage(offset = 0) {
  const response = await api.get("/customers", {
    params: { limit: CUSTOMER_ARCHIVE_PAGE_SIZE + 1, offset },
  });
  const records = Array.isArray(response.data) ? response.data : [];
  return {
    items: records.slice(0, CUSTOMER_ARCHIVE_PAGE_SIZE),
    hasMore: records.length > CUSTOMER_ARCHIVE_PAGE_SIZE,
  };
}
